<template>
  <div>
    <table v-if="rows.length > 0" class="table table-container">
      <thead>
      <tr>
        <th v-for="col in columns" :key="col.key" scope="col">{{ col.label }}</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(entry, displayIndex) in sortedRows" :key="displayIndex"
          :class="{'light-teal-bg-selected': originalIndex(displayIndex) === editingIndex}">
        <slot :row="entry" :index="originalIndex(displayIndex)">
          <td v-for="col in columns" :key="col.key">{{ entry[col.key] || '-' }}</td>
        </slot>
        <td>
          <div class="form-table-buttons float-right">
            <a class="edit-icon" title="Edit" @click="$emit('edit', originalIndex(displayIndex))">
              <font-awesome-icon icon="edit"/>
            </a>
            <a class="delete-icon" title="Delete" @click="$emit('delete', originalIndex(displayIndex))">
              <font-awesome-icon icon="trash"/>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="!showForm" class="add-item-container" @click="$emit('toggle-form')">
      <p>Click to add {{ addLabel }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormTable",
  props: {
    rows: { type: Array, required: true },
    columns: { type: Array, required: true },
    editingIndex: { type: Number, default: null },
    sortKey: { type: String, default: null },
    addLabel: { type: String, required: true },
    showForm: { type: Boolean, default: false },
  },
  emits: ['edit', 'delete', 'toggle-form'],
  computed: {
    indexedRows() {
      return this.rows.map((row, index) => ({ row, originalIndex: index }));
    },
    sortedIndexedRows() {
      if (!this.sortKey) return this.indexedRows;
      return [...this.indexedRows].sort((a, b) => {
        const aVal = Number(a.row[this.sortKey]) || 0;
        const bVal = Number(b.row[this.sortKey]) || 0;
        return aVal - bVal;
      });
    },
    sortedRows() {
      return this.sortedIndexedRows.map(entry => entry.row);
    },
  },
  methods: {
    originalIndex(displayIndex) {
      return this.sortedIndexedRows[displayIndex].originalIndex;
    },
  },
}
</script>

<style scoped>
.table {
  border-collapse: collapse;
  width: 100%;
}

.table-container {
  background-color: #fafffe;
  padding: 1rem;
  margin-bottom: 0;
}

.add-item-container {
  background-color: #fafffe;
  padding: 1rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.add-item-container p {
  margin-bottom: 0;
}

.add-item-container:hover {
  color: #003536;
}

.form-table-buttons {
  white-space: nowrap;
}

.form-table-buttons a {
  font-size: x-large;
}

.delete-icon {
  margin-left: 1rem;
}

td {
  vertical-align: middle;
}
</style>
